import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useSnackbar } from 'notistack';
import useMediaQuery from '@material-ui/core/useMediaQuery/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import { useModal } from '../../utils/modal';

import api from '../../utils/api';
import CardModal from '../stripe/CardModal';

import { fetchUserData, confimStripeCard } from '../../store/actions/account';

import { Elements } from '@stripe/react-stripe-js';
import { useStripe } from '../../contexts/StripeContext';

function CreditCard() {
  const modal = useModal();
  const { t } = useTranslation(['account', 'payment_method', 'common']);
  const [setupIntent, setSetupIntent] = useState(null);
  const { stripePromise, loading } = useStripe();
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    if (stripePromise) {
      openIntent();
    }
  }, [stripePromise]);

  const openIntent = async () => {
    try {
      const response = await api.user.createStripeSetupIntents();
      setSetupIntent(response.stripe_setup_intent);
    } catch (error) {
      throw error;
    }
  };

  const confirmCard = async confirmMethod => {
    try {
      const response = await dispatch(
        confimStripeCard(setupIntent.id, confirmMethod.payment_method, false)
      );
      enqueueSnackbar(t('payment_method:add-payment-methods-success'), {
        variant: 'success'
      });
      await dispatch(fetchUserData());
    } catch (error) {
      throw error;
    }
  };

  const onResult = result => {
    if (result.error && result.error.message) {
      enqueueSnackbar(result.error.message, { variant: 'error' });
    } else if (result && result.setupIntent) {
      confirmCard(result.setupIntent);
    } else {
      enqueueSnackbar(t('common:error'), { variant: 'error' });
    }
  };

  if (loading) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        {t('common:loading')}...
      </div>
    );
  }

  // Show the form even if Stripe is not loaded yet, Elements can handle a Promise
  return (
    <div>
      {stripePromise ? (
        <Elements stripe={stripePromise}>
          <CardModal
            isModal={false}
            isMobile={isMobile}
            setupIntent={setupIntent}
            open={modal.isOpen}
            onClose={modal.close}
            onResult={onResult}
          />
        </Elements>
      ) : (
        <div style={{ padding: '40px', textAlign: 'center' }}>
          <p>{t('payment_method:unable-to-load-payment-form')}</p>
        </div>
      )}
    </div>
  );
}

export default CreditCard;
